var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Base } from "@studiometa/js-toolkit";
import { withTransition } from "../../decorators/index.js";
class Transition extends withTransition(Base) {
}
__publicField(Transition, "config", {
  name: "Transition"
});
export {
  Transition
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
